class ActionTypes {
    static INSTRUCTION = "Instruction";
    static PROGRAM_ASSEMBLE = "ProgramAssemble";
    static STEP_INSTRUCTION = "StepInstruction";
    static RUN_PROGRAM = "RUN_PROGRAM";
}

export default ActionTypes;